import React from 'react';

import { defineMessages, FormattedMessage } from 'react-intl-next';
import { componentWithFG } from '@confluence/feature-gate-component';

export const commonCardI18n = defineMessages({
	createPageTitle: {
		id: 'experiment-home-onboarding-takeover-v2.create-page.title',
		defaultMessage: 'Create a page',
		description:
			'This will be shown as a title on a card embedded into the home screen as a part of onboarding.',
	},
	createLiveDocTitle: {
		id: 'experiment-home-onboarding-takeover-v2.create-livedoc.title',
		defaultMessage: 'Create a live doc',
		description:
			'This will be shown as a title on a card embedded into the home screen as a part of onboarding.',
	},
	createPageDescription: {
		id: 'experiment-home-onboarding-takeover-v2.create-page.description',
		defaultMessage:
			'Plan projects, take notes, and track tasks. Try a template or start from scratch.',
		description:
			'This will be shown as a description on a card embedded into the home screen as a part of onboarding.',
	},
	createPageCTA: {
		id: 'experiment-home-onboarding-takeover-v2.create-page.cta',
		defaultMessage: 'Create page',
		description:
			'This will be shown on a button embedded into the home screen as a part of onboarding. Clicking the button will create a page and land them in the editor',
	},
	createLiveDocCTA: {
		id: 'experiment-home-onboarding-takeover-v2.create-livedoc.cta',
		defaultMessage: 'Create live doc',
		description:
			'This will be shown on a button embedded into the home screen as a part of onboarding. Clicking the button will create a live doc and land them in the editor',
	},
	createSpaceTitle: {
		id: 'experiment-home-onboarding-takeover-v2.create-space.title',
		defaultMessage: 'Set up a team space',
		description:
			'This will be shown as a title on a card embedded into the home screen as a part of onboarding.',
	},
	createSpaceDescription: {
		id: 'experiment-home-onboarding-takeover-v2.create-space.description',
		defaultMessage: 'Create a single source of truth for your team’s projects and docs.',
	},
	createWhiteboardTitle: {
		id: 'experiment-home-onboarding-takeover-v2.create-whiteboard.title',
		defaultMessage: 'Brainstorm on a whiteboard',
		description:
			'This will be shown as a title on a card embedded into the home screen as a part of onboarding.',
	},
	createWhiteboardDescription: {
		id: 'experiment-home-onboarding-takeover-v2.create-whiteboard.description',
		defaultMessage: 'Dream up new ideas and visualize your work.',
		description:
			'This will be shown as a description on a card embedded into the home screen as a part of onboarding.',
	},
	createWhiteboardCTA: {
		id: 'experiment-home-onboarding-takeover-v2.create-whiteboard.cta',
		defaultMessage: 'Create whiteboard',
		description:
			'This will be shown on a button embedded into the home screen as a part of onboarding. Clicking the button will create a whiteboard and land them in the whiteboard editor',
	},
});

const FormattedMessageCreateLiveDocCTA = () => (
	<FormattedMessage {...commonCardI18n.createLiveDocCTA} />
);
const FormattedMessageCreatePageCTA = () => <FormattedMessage {...commonCardI18n.createPageCTA} />;

const FormattedMessageCreateLiveDocTitle = () => (
	<FormattedMessage {...commonCardI18n.createLiveDocTitle} />
);
const FormattedMessageCreatePageTitle = () => (
	<FormattedMessage {...commonCardI18n.createPageTitle} />
);
export const RenderedFormattedMessageCreateCTA = componentWithFG(
	'confluence_live_pages_open_beta_trait_opted_in',
	FormattedMessageCreateLiveDocCTA,
	FormattedMessageCreatePageCTA,
);

export const RenderedFormattedMessageCreateTitle = componentWithFG(
	'confluence_live_pages_open_beta_trait_opted_in',
	FormattedMessageCreateLiveDocTitle,
	FormattedMessageCreatePageTitle,
);
